import { Checkbox, CheckboxGroup, Flex, IconButton, Link, Menu, Portal, Text } from '@lego/klik-ui';
import { Filter, FilterBold } from '@lego/klik-ui/icons';
import type { RowData } from '@tanstack/react-table';
import type { Column } from '../appTable';

export const SingleSelectFilter = <T extends RowData>({ column }: { column: Column<T> }) => {
  return (
    <Menu closeOnBlur>
      <Menu.Button as={Link} mr={2} tabIndex={0}>
        {column.getFilterValue() === undefined ? (
          <IconButton aria-label="Menu" icon={<Filter />} size="xs" variant="ghost" />
        ) : (
          <IconButton aria-label="Menu" icon={<FilterBold />} size="xs" variant="ghost" />
        )}
      </Menu.Button>
      <Portal>
        <Menu.List maxH="min(300px, calc(100dvh - 2rem))" overflowY="auto">
          <CheckboxGroup>
            <Flex justifyContent="space-between" p={2}>
              <Text>All</Text>
              <Checkbox
                isChecked={column.getFilterValue() === undefined}
                onChange={() => column.setFilterValue(undefined)}
              />
            </Flex>
            {column.columnDef.meta?.filterVariant?.type === 'singleSelect' &&
              column.columnDef.meta?.filterVariant?.options.map(({ name, filterValue }) => (
                <Flex justifyContent="space-between" key={name} p={2}>
                  <Text>{name}</Text>
                  <Checkbox
                    isChecked={column.getFilterValue() === filterValue}
                    onChange={() => column.setFilterValue(filterValue)}
                  />
                </Flex>
              ))}
          </CheckboxGroup>
        </Menu.List>
      </Portal>
    </Menu>
  );
};
